import { createListAtoms } from "../../common/DataList";
import { rechercherOperateurs } from "./operateursApi";

// ============================================================
// Listes des opérateurs (CE-1404) — configuration pure (testable sans DOM).
// Deux vues sur la même base : « Répertoire des opérateurs » (tous) et
// « Opérateurs d'accompagnement » (au moins un régime, critère
// avecRegimeSeulement de POST /operateurs/recherche). Chaque vue garde sa
// propre recherche mémorisée. La route répond { donnees, total, page,
// parPage } : le fetcher la rabat sur le { data, count } attendu par le kit.
// ============================================================

export const DELAI_RECHERCHE = 800;
export const OPERATEURS_ENDPOINT = "operateurs/recherche";
// Pas de filtre de rattachement : toute structure est rattachée à la Caf.
// La recherche libre s'appelle `terms`, la clé que le kit lit pour l'état
// vide et la réinitialisation ; le contrat de l'API la reçoit en `terme`.
export const OPERATEURS_DEFAULT_FILTERS = {
  terms: "",
  regime: "",
  statut: "",
};

export const REPERTOIRE_PERSIST_KEY = "espoar.boa.operateurs.repertoire.search";
export const ACCOMPAGNEMENT_PERSIST_KEY = "espoar.boa.operateurs.accompagnement.search";

export const repertoireAtoms = createListAtoms({
  defaultFilters: OPERATEURS_DEFAULT_FILTERS,
  persistKey: REPERTOIRE_PERSIST_KEY,
});

export const accompagnementAtoms = createListAtoms({
  defaultFilters: OPERATEURS_DEFAULT_FILTERS,
  persistKey: ACCOMPAGNEMENT_PERSIST_KEY,
});

export const GROUPES_FILTRES_OPERATEURS = [{ id: "operateur", title: "Opérateur" }];

// Le kit ajoute lui-même l'option vide « Tous » en tête d'un champ segmenté.
const CHOIX_REGIME = [
  { id: "TOTAL", name: "Total" },
  { id: "PARTIEL", name: "Partiel" },
];

// Le répertoire montre les quatre statuts ; la vue d'accompagnement ne peut
// pas contenir d'opérateur « Actif » (statut des structures sans régime).
const CHOIX_STATUT = [
  { id: "ACTIF", name: "Actif" },
  { id: "EN_PREPARATION", name: "En préparation" },
  { id: "EN_SERVICE", name: "En service" },
  { id: "INACTIF", name: "Inactif" },
];

export const definitionsFiltresOperateurs = ({ avecRegimeSeulement = false } = {}) => [
  {
    name: "regime",
    group: "operateur",
    label: "Régime",
    type: "segmented",
    principal: true,
    options: CHOIX_REGIME,
  },
  {
    name: "statut",
    group: "operateur",
    label: "Statut",
    type: "segmented",
    principal: true,
    options: avecRegimeSeulement ? CHOIX_STATUT.filter((s) => s.id !== "ACTIF") : CHOIX_STATUT,
  },
];

export function buildOperateursPayload(search, { avecRegimeSeulement = false } = {}) {
  const filters = (search && search.filters) || {};
  const criteres = {
    page: Number(search && search.page) || 1,
    parPage: Number(search && search.nbItemsByPage) || 25,
  };
  const terme = String(filters.terms || "").trim();
  if (terme) criteres.terme = terme;
  if (filters.regime) criteres.regimes = [filters.regime];
  if (filters.statut) criteres.statuts = [filters.statut];
  if (avecRegimeSeulement) criteres.avecRegimeSeulement = true;
  return criteres;
}

// Même signature que le fetcher du kit (endpoint, payload) ; la route est
// fixe ici, portée par rechercherOperateurs.
export const operateursFetcher = (_endpoint, criteres) =>
  rechercherOperateurs(criteres).then((reponse) => ({
    data: (reponse && reponse.donnees) || [],
    count: Number(reponse && reponse.total) || 0,
  }));
